import { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { actions, Form } from 'forms/rrf';
import { getNonPpcMcSettings, saveNonPpcMcSettings } from '../../../actions/non-ppc-mc-settings';
import ArrowButton from '../../common/button-arrow';
import RequiredPointRedemptionDate from '../../common/form/required-point-redemption-date';
import PointRedemptionDate from '../../common/form/point-redemption-date';

const model = 'point_redemption_date';

class NonPpcMcSettingsForm extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getNonPpcMcSettings());
  }

  addPointRedemptionDate = () => {
    const { dispatch } = this.props;

    dispatch(actions.push('deep.admin_non_ppc_mc_settings.point_redemption_dates', ''));
  };

  onSubmit = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields('deep.admin_non_ppc_mc_settings', saveNonPpcMcSettings(payload)));
  };

  onDeletePointRedemptionDate = (index) => {
    const { dispatch } = this.props;

    dispatch(actions.remove('deep.admin_non_ppc_mc_settings.point_redemption_dates', index));
  };

  render() {
    const { pointRedemptionDates, formValid } = this.props;

    return (
      <Form model="deep.admin_non_ppc_mc_settings" onSubmit={this.onSubmit}>
        <RequiredPointRedemptionDate model={model} label="Points Redemption Dates" />
        { pointRedemptionDates.map((pointRedemptionDate, index) => (
          <PointRedemptionDate
            key={index}
            index={index}
            model={model}
            onDelete={this.onDeletePointRedemptionDate}
          />
        ))}
        <Row>
          <Col lg={12}>
            <FormGroup>
              <ArrowButton
                submit={false}
                arrow={false}
                onClick={this.addPointRedemptionDate}
                color="grey"
              >
                Add date
              </ArrowButton>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton
              color="grey"
              className="float-end"
              disabled={!formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_non_ppc_mc_settings.$form.valid,
  pointRedemptionDates: state.deep.admin_non_ppc_mc_settings.point_redemption_dates
});

export default connect(mapStateToProps)(NonPpcMcSettingsForm);
